import {I18n} from '@aws-amplify/core';
import {AiOutlineCreditCard} from 'react-icons/ai';

import {SimplePageHeader} from '@flexinet/ui-components';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton';

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Payment events')}
            icon={<AiOutlineCreditCard/>}
            tools={[<ReloadRecordsButton key='reload'/>]}
        />
    );
};
